import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyEnvironmentFavicon } from './app/shared/Utils/environment-favicon';

if (environment.production) {
  enableProdMode();
}

applyEnvironmentFavicon(environment.favicon_set);
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
